import React from "react";
import PropTypes from "prop-types";
import FilterListIcon from "@mui/icons-material/FilterList";

export default function FilterButton({ filterValue, onClick }) {
  return (
    <FilterListIcon 
      sx={{ ...filterValue ? {color: "success.60"} : {color: "black_opacity.60" }, fontSize: 20 }}
      className="filter-arrow"
      onClick={onClick}
    />
  );
}

FilterButton.propTypes = {
  filterValue: PropTypes.any,
  onClick: PropTypes.func.isRequired
};